export default [
  {
    title: 'breadcrumb.parley',
    route: 'parley',
    icon: '',
    resource: 'parley-setup',
    action: 'read',
  }
];